import React from 'react'

const propTypes = {
  zoomIncrement: React.PropTypes.func.required,
  zoomDecrement: React.PropTypes.func.required,
  unsetSelectedEntity: React.PropTypes.func.isRequired,
}

class Zoom extends React.Component {

  constructor(props) {
    super(props)

    this.handleZoomIn = this.handleZoomIn.bind(this)
    this.handleZoomOut = this.handleZoomOut.bind(this)
  }

  handleZoomIn(event) {
    this.props.unsetSelectedEntity()
    this.props.zoomIncrement()
  }

  handleZoomOut(event) {
    this.props.unsetSelectedEntity()
    this.props.zoomDecrement()
  }

  shouldComponentUpdate() {
    return false
  }

  render() {

    return (
      <div className="Zoom">

        <button onClick={this.handleZoomIn} className="Zoom-in">
          
        </button>

        <button onClick={this.handleZoomOut} className="Zoom-out">
          
        </button>

      </div>
    )
  }
}

Zoom.propTypes = propTypes

export default Zoom


// WEBPACK FOOTER //
// ./src/components/Zoom.js